import React, { FC, memo } from 'react'
import styled from 'styled-components'

import Text from '../../../ui/Text'

const SInfoField = styled.label`
    font-size: 21px;
    line-height: 28px;
    display: block;
`

type TitleTextFieldProps = {
    titleCode: string
    text: string
    dataTestId?: string
}

const TitleTextField: FC<TitleTextFieldProps> = ({ titleCode, text, dataTestId }) => {
    return (
        <div className="margin-top-small">
            <Text code={titleCode} />
            <SInfoField data-testid={`${dataTestId}-text`}>{text}</SInfoField>
        </div>
    )
}

export default memo(TitleTextField)
